import React from 'react';

import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';

import { spreadProps } from '../dom/dom';

/**
 * Function for link action style
 * @function getLinkHtml
 * @param { object }  - returns an object with the appropriate HTML markup
 */
export const getLinkHtml = ( data ) => {
  const {
    action,
    actionSize,
    actionStyle,
    derivedAriaLabel,
    fullyClickableParent,
    iconName,
    iconPosition,
    isKnockoutLink,
    textForScreenReaders // used when a component is fully clickable. If false will add a tab-index = -1 to avoid duplicate links for ADA
  } = data;

  /* Determine if the button needs a negative tab index */
  const hasNegIndex = ( !textForScreenReaders && fullyClickableParent );
  const updateTabIndex = hasNegIndex ? -1 : undefined;
  const updateAriaHidden = hasNegIndex ? true : undefined;

  /* Determine if aria-label is needed */
  const needAriaLabel = !hasNegIndex && !textForScreenReaders;
  const updateAriaLabel = needAriaLabel ? derivedAriaLabel : undefined;
  const updateScreenReaderText = action?.label ? undefined : textForScreenReaders;

  return (
    <>
      <Link_Huge
        { ...spreadProps( { ...action } ) }
        { ...spreadProps( {
          ariaHidden: updateAriaHidden,
          iconImage: iconName,
          iconPosition
        } ) }
        action={ action } // We need to pass this specifically for the action to work with DC and everything else that comes with Link_Huge. Palette bundles this as one object and doesn't compose the action props the way web-site needs them. We did this this way to keep business logic out of Palette
        ariaLabel={ updateAriaLabel }
        fullyClickableParent={ fullyClickableParent }
        isKnockoutLink={ isKnockoutLink }
        screenReaderText={ updateScreenReaderText }
        size={ actionSize }
        tabIndex={ updateTabIndex }
        variant={ actionStyle }
      >
        { action?.label }
      </Link_Huge>
    </>
  );
};